import { Button, Checkbox, Col, Menu, Modal, Row } from "antd"
import SubMenu from "antd/lib/menu/SubMenu";
import { useEffect, useState } from "react";
import apiMaestras from "../../../api/Maestras/api-maestras";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { ObjNotificaciones } from "../../../config/notificaciones";
import { useMaestras } from "../../../hooks/useMaestras";

export const ModalLineas = ({ openModal, setOpenModal, id_postulacion, setOpenModalAnterior, obtenerJurados, tipoPostulacion }: any) => {

  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([])
  const obtenerLineasConvocatorias = async () => {
    try {
      const { linea_convocatorias } = await apiMaestras.obtenerLineasConConvocatorias();
      const lineaConvocatoriaMap = linea_convocatorias.map((x: any) => {
        return {
          ...x,
          categorias: x.categorias.map((c: any) => {
            return {
              ...c,
              checked: false,
              id_linea: x.id
            }
          })
        }
      })
      setLineasConvocatorias(lineaConvocatoriaMap);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      obtenerLineasConvocatorias();
    }
    return () => {
      mounted = false;
    }
  }, [])

  const onCancel = () => {
    setOpenModal(false);
  }

  const handleCategoriaChange = (e: any, categoria: any) => {
    const arraySet = lineasConvocatorias.map((x: any) => {
      return {
        ...x,
        categorias: x.categorias.map((c: any) => {
          if (c.id == categoria.id) {
            return {
              ...c,
              checked: e
            }
          }

          return {
            ...c,
          }

        })
      }
    })
    setLineasConvocatorias(arraySet)
  }

  const guardar = async () => {
    let lineasfiltradas: any = [];
    lineasConvocatorias.filter((x: any) => {
      x.categorias.filter((c: any) => {
        if (c.checked === true) {
          lineasfiltradas = [...lineasfiltradas, c]
        }
      })
    })

    try {
      if (lineasfiltradas.length === 0) {
        return ObjNotificaciones.MSG_ERROR('warning', '¡Error faltan datos!', 'Por favor, selecciona al menos un criterio');
      } else {
        await apiParticipantes.actualizarCategoriasPropuesta(id_postulacion, lineasfiltradas);
        setOpenModalAnterior(false);
        obtenerJurados(tipoPostulacion);
        onCancel();
      }
    } catch (error) {
      console.log(error)
    }

  }


  return (
    <Modal
      className="ant-modal-close-x2"
      visible={openModal}
      onCancel={onCancel}
      width={1400}
      title={"Seleccionar líneas"}
      footer={
        <>
          <div className="d-flex justify-content-end">
            <div>
              <Button className="button-gray-ghost pe-4" onClick={onCancel}>
                Cerrar
              </Button>
            </div>
            <div>
              <Button className="button-azul-radius" onClick={guardar}>
                Finalizar postulación de jurado
              </Button>
            </div>
          </div>
        </>
      }
    >
      <div className="row">

        <div>
          <Menu
            mode="inline"
            className="menu"



          >
            {lineasConvocatorias?.map((linea: any) =>
              <SubMenu
                className="border-bottom"

                key={linea.id} title={


                  <div className="d-flex">
                    <div className="d-flex d-inline-block text-truncate hovernone">{linea.nombre}</div>
                    {/* CLASE PARA OCULTAR EN MOBILE SELECCIONADOS */}
                    <div className="ps-4 font-family-Montserrat-Regular font-size-10px font-color-F28C02 d-sm-block d-none">(Seleccionado: {linea.categorias.filter((c: any) => c.checked == true).length})</div>
                  </div>

                }>
                <div className="container__categorias__item">
                  {linea.categorias.map((categoria: any,i) =>
                    <div key={i} className="pt-2 pb-3 border-bottom "><Checkbox checked={categoria.checked} onChange={(e) => handleCategoriaChange(e.target.checked, categoria)}><span className="font-family-Montserrat-Regular text-wrap lh-base">{categoria.nombre}</span></Checkbox></div>
                  )}
                </div>
              </SubMenu>
            )}

          </Menu>
        </div>
      </div>
    </Modal>
  )
}
